// SampleCard.js

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen, faInbox, faTruck, faMapMarkerAlt, faEnvelope, faCalendarAlt, faBoxes } from '@fortawesome/free-solid-svg-icons';
import './SampleCard.css';

// The component receives 'sample' prop, which is now our correctly transformed order object.
const SampleCard = ({ sample, onClick }) => {
    const statusIcons = {
        'Order Received': faInbox,
        'Sent Cargo': faTruck,
        'Cargo Delivered': faBoxOpen, // New icon
    };

    // Helper function to parse and format address
    const getAddressInfo = (addressString) => {
        if (!addressString || typeof addressString !== 'string') return null;
        try {
            const address = JSON.parse(addressString);
            if (typeof address !== 'object' || address === null) return null;
            return `${address.city || ''}, ${address.country || ''}`.replace(/^,\s*|,\s*$/g, '');
        } catch (e) {
            return null;
        }
    };

    // Helper function to format date
    const formatDate = (dateString) => {
        if (!dateString) return null;
        try {
            return new Date(dateString).toLocaleDateString();
        } catch (e) {
            return null;
        }
    };

    // The onClick prop comes from the parent (SampleCardsSection).
    // This function calls it.
    const handleCardClick = () => {
        if (onClick) {
            onClick(sample);
        }
    };

    if (!sample || !sample.status) {
        return null;
    }

    const addressInfo = getAddressInfo(sample.address);
    const orderDate = formatDate(sample.status.stages['Order Received']);

    return (
        // The onClick is attached here.
        <div className="samplemanager-card" onClick={handleCardClick}>
            <div className="samplemanager-card-header">
                <FontAwesomeIcon 
                    icon={statusIcons[sample.status.currentStage] || faInbox} 
                    className="samplemanager-card-icon" 
                />
                <span className="samplemanager-card-status">{sample.status.currentStage}</span>
            </div>
            <div className="samplemanager-card-body">
                <div className="samplemanager-card-patient">
                    <span className="samplemanager-card-name">{sample.firstName} {sample.lastName}</span>
                </div>
                <div className="samplemanager-card-details">
     
                    {/* Display the new kit summary from the 'kitType' field. */}
                    <div className="samplemanager-card-detail">
                        <span className="samplemanager-card-label">Items:</span>
                        <span className="samplemanager-card-value">
                            <FontAwesomeIcon icon={faBoxes} className="samplemanager-card-detail-icon" />
                            {sample.items ? sample.items.length : 0} kit{sample.items && sample.items.length !== 1 ? 's' : ''}
                        </span>
                    </div>
                    {/* Display email if available */}
                    {sample.email && (
                        <div className="samplemanager-card-detail">
                            <span className="samplemanager-card-label">Email:</span>
                            <span className="samplemanager-card-value">
                                <FontAwesomeIcon icon={faEnvelope} className="samplemanager-card-detail-icon" />
                                {sample.email}
                            </span>
                        </div>
                    )}
                    {/* Display location if available */}
                    {addressInfo && (
                        <div className="samplemanager-card-detail">
                            <span className="samplemanager-card-label">Location:</span>
                            <span className="samplemanager-card-value">
                                <FontAwesomeIcon icon={faMapMarkerAlt} className="samplemanager-card-detail-icon" />
                                {addressInfo}
                            </span>
                        </div>
                    )}
                    {/* Display order date if available */}
                    {orderDate && (
                        <div className="samplemanager-card-detail">
                            <span className="samplemanager-card-label">Ordered:</span>
                            <span className="samplemanager-card-value">
                                <FontAwesomeIcon icon={faCalendarAlt} className="samplemanager-card-detail-icon" />
                                {orderDate}
                            </span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SampleCard;